<template>
  <v-container fluid class="grey lighten-2" style="height:100%;">
    <v-row justify="center" align="center" style="height:100%;">
      <v-col cols="6">
        <v-card>
          <v-card-title>
            <div>
              <v-icon x-large color="red" class="mr-2">mdi-server-network-off</v-icon>
              服务器内部错误
            </div>
            <v-spacer/>
            <router-link class="text-decoration-none body-1 mr-4" to="/">返回首页</router-link>
            <router-link class="text-decoration-none body-1 mr-4" to="/msgboard">联系客服</router-link>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="text-h5">
                抱歉，系统出现了一点小问题
              </v-col>
              <v-col cols="12">
                系统已经自动通知管理员，您可以先尝试其它功能
              </v-col>
              <v-col cols="12">
                可能原因：
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-row dense class="pl-8">
                  <v-col cols="12">
                    参数不正确 > 您提交的数据参数非法
                  </v-col>
                  <v-col cols="12">
                    路径不正确 > 您输入的页面路径不正确
                  </v-col>
                </v-row>

              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {

}
</script>